import Http from '@/api/http.js'

export default {
  create(order){
    return Http.post(`/orders`, {
      order
    })
  },
  createRetailOrder(order){
    return Http.post(`/create_retail_orders`, {
      order
    })
  },
  lastWholesaleOrders({client_id, modality_id}){
    return Http.get(`/last_orders`, {
      params: {
        client_id,
        modality_id,
        solution: 'wholesale'
      }
    })
  },
  lastRetailOrders({client_id, modality_id}){
    return Http.get(`/last_orders`, {
      params: {
        client_id,
        modality_id,
        solution: 'retail'
      }
    })
  },
}
